import {
  theDomWatcher,
  handleNewsletterSubscribed,
  trackNewsletterSignup,
  validateNewsletterEmail,
  initProductDescriptions,
} from "@theme/helpers";

const featureLoaders = [
  {
    label: "cart",
    selectors: ["[data-cart-drawer]", "[data-cart-container]", "[data-open-cart]"],
    observe: true,
    loader: () => import("@theme/cart"),
  },
  {
    label: "announcement-bar",
    selectors: ["[data-announcement-bar]"],
    loader: () => import("@theme/announcement-bar"),
  },
  {
    label: "mobile-menu",
    selectors: ["[data-mobile-menu]"],
    loader: () => import("@theme/mobile-menu"),
  },
  {
    label: "hero-slider",
    selectors: [".hero-slider [data-blaze-slider]"],
    loader: () => import("@theme/hero-slider"),
  },
  {
    label: "tabbed-slider",
    selectors: ["[data-tabbed-slider]"],
    loader: () => import("@theme/tabbed-slider"),
  },
  {
    label: "card-quick-add",
    selectors: ["[data-card-quick-add]"],
    observe: true,
    loader: () => import("@theme/card-quick-add"),
  },
  {
    label: "image-showcase",
    selectors: ["[data-image-showcase]"],
    loader: () => import("@theme/image-showcase"),
  },
  {
    label: "featured-collections",
    selectors: ["[data-featured-collections]"],
    loader: () => import("@theme/featured-collections"),
  },
  {
    label: "shop-the-look",
    selectors: ["[data-stl-modal]"],
    loader: () => import("@theme/shop-the-look"),
  },
  {
    label: "collection-filters-panel",
    selectors: ["[data-filters-panel]"],
    loader: () => import("@theme/collection-filters-panel"),
  },
  {
    label: "mega-menu-slider",
    selectors: ["[data-mega-slider]"],
    loader: () => import("@theme/mega-menu-slider"),
  },
  {
    label: "toasty",
    selectors: ["body"],
    loader: () => import("@theme/toasty"),
  },
  {
    label: "product-quick-add",
    selectors: ["[quick-add-qf]", "product-form"],
    observe: true,
    loader: () =>
      import("@theme/product-quick-add").then(({ ProductQuickAdd }) => new ProductQuickAdd()),
  },
  {
    label: "main-product",
    selectors: ["main-product"],
    observe: true,
    loader: () => import("@theme/main-product"),
  },
  {
    label: "product-gallery-grid",
    selectors: ['[gallery-container][data-gallery-style="grid"]'],
    loader: () => import("@theme/product-gallery"),
  },
  // {
  //   label: "product-form",
  //   selectors: ["product-form"],
  //   observe: true,
  //   loader: () => import("@theme/option-selectors").then(({ ProductForm }) => new ProductForm()),
  // },
  {
    label: "product-card",
    selectors: ["product-card"],
    loader: () => import("@theme/product-card").then(({ ProductCard }) => new ProductCard()),
  },
  {
    label: "custom-option-dropdown",
    selectors: ["custom-option-dropdown"],
    observe: true,
    loader: () => import("@theme/custom-option-dropdown"),
  },
  {
    label: "predictive-search",
    selectors: ["predictive-search"],
    loader: () => import("@theme/search").then(({ SearchController }) => new SearchController()),
  },
  {
    label: "menu",
    selectors: ["#open-mobile-menu", ".mobile-menu-outer-wrapper"],
    loader: () => import("@theme/menu").then(({ MenuController }) => new MenuController()),
  },
  {
    label: "accordion",
    selectors: [".accordion"],
    loader: () =>
      import("@theme/accordion").then(({ AccordionController }) => {
        if (window.__quickfireAccordionController) {
          return window.__quickfireAccordionController;
        }
        const instance = new AccordionController();
        window.__quickfireAccordionController = instance;
        return instance;
      }),
  },
  {
    label: "product-quantity",
    selectors: ["[quantity-select]"],
    observe: true,
    loader: () =>
      import("@theme/product-quantity").then(({ ProductQuantity }) => new ProductQuantity()),
  },
  {
    label: "header-layout",
    selectors: ["[data-header-layout]"],
    loader: () =>
      import("@theme/header-layout").then(
        ({ HeaderLayoutController }) => new HeaderLayoutController(),
      ),
  },
  {
    label: "header-scroll",
    selectors: [".header-outer-shopify-wrapper"],
    loader: () =>
      import("@theme/header-scroll").then(
        ({ HeaderScrollController }) => new HeaderScrollController(),
      ),
  },
  {
    label: "modal-controller",
    selectors: ["[data-modal-trigger]", "[data-modal]"],
    loader: () =>
      import("@theme/modal-controller").then(({ ModalController }) => {
        if (window.__quickfireModalController) {
          return window.__quickfireModalController;
        }
        const instance = new ModalController();
        window.__quickfireModalController = instance;
        return instance;
      }),
  },
  {
    label: "lightbox",
    selectors: ["[data-lightbox-modal]"],
    observe: true,
    loader: () =>
      import("@theme/lightbox").then(({ bootstrapLightbox }) => bootstrapLightbox()),
  },
  {
    label: "slider-mobile-grid",
    selectors: ["[data-mobile-grid-slider]"],
    observe: true,
    loader: () => import("@theme/slider-mobile-grid"),
  },
];

featureLoaders.forEach(({ selectors, loader, label, observe }) =>
  theDomWatcher(selectors, loader, { label, observe }),
);

theDomWatcher(
  "[data-blaze-slider]",
  () =>
    import("@theme/blaze-slider-controller").then(({ blazeSliderController }) => {
      blazeSliderController.init(document);
      return blazeSliderController;
    }),
  { label: "blaze-slider", observe: true },
);

theDomWatcher("form.newsletter-form", handleNewsletterSubscribed, { label: "newsletter-form" });
theDomWatcher("form.newsletter-form", validateNewsletterEmail, { label: "newsletter-validation" });
theDomWatcher('input[name="contact[email]"]', trackNewsletterSignup, {
  label: "newsletter-signup",
});
theDomWatcher("[read-more-container]", initProductDescriptions, { label: "read-more" });
